module.exports = __webpack_public_path__ + "static/media/HanoiEx-1.8b3c534a.jpeg";